import { registerPage } from '@zillow/client-profiler-interface-cs';
import { logError } from '@zg-rentals/log-error';
import { store } from 'app/shared/flux/store/configureStore';

function getPlatform(deviceType: string): string {
  if (deviceType === 'mobile') return 'mobile';
  return 'desktop';
}

export function registerClientProfilerPage(pageName: string) {
  if (typeof window === 'undefined') return;

  const state = store.getState();

  try {
    registerPage({
      pageName,
      environment: state.app.zgEnv || 'localhost',
      platform: getPlatform(state.app.device.deviceType),
    });
  } catch (e) {
    logError({
      error: e,
      errorType: 'ClientProfilerRegistrationError',
      context: { pageName },
    });
  }
}
